exports = module.exports = require("../../../node_modules/.pnpm/css-loader@1.0.1_webpack@4.46.0/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n/* layout contants from `layout-constants.js` */\n.user-avatar_user-thumbnail_jSYS1 {\n    width: 2rem;\n    height: 2rem;\n    border-radius: calc(0.5rem / 1);\n    vertical-align: middle;\n    box-shadow: 0 0 0 1px var(--ui-black-transparent, hsla(55, 20%, 20%, 0.15));\n    transition: box-shadow 0.3s ease;\n}\n.user-avatar_user-thumbnail_jSYS1:hover {\n    box-shadow: 0 0 20px 10px rgba(255, 255, 255, 0.5);\n}\n", ""]);

// exports
exports.locals = {
	"user-thumbnail": "user-avatar_user-thumbnail_jSYS1",
	"userThumbnail": "user-avatar_user-thumbnail_jSYS1"
};